import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { Router, NavigationExtras } from "@angular/router";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  private extras: NavigationExtras | undefined;

  constructor(private authService: AuthService, private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      const errorMessage = err.error.message || err.statusText;
      this.extras = {
        state: {
          error: errorMessage
        }
      };
      if (err.status === 401 || err.status === 409) {
        this.router.navigate(['/auth-error'], this.extras).then();
      } else {
        this.router.navigate(['/server-error']).then();
      }
      return throwError(errorMessage);
    }));
  }
}
